import { createRequest, RequestConfig } from 'app/common/api';

import { TNewTariffProfile } from '../core/tariff-profile';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_tariff_profile',
};

export const addTariffProfileRequest = (newTariffProfile: TNewTariffProfile) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(newTariffProfile),
  });
